import { DivergenciasUnificadasTable } from '@/components/divergencias';
import type { ConciliacaoFilterDto, ConciliacaoResponseDto } from '@/services/conciliacao-fiscal';
import { useCallback, useState } from 'react';
import ExportDialog from './export-dialog';

interface DetailedAnalysisSectionProps {
  data: ConciliacaoResponseDto;
  onPageChange?: (page: number) => void;
  loading?: boolean;
  currentFilters?: ConciliacaoFilterDto;
}

export default function DetailedAnalysisSection({
  data,
  onPageChange,
  loading = false,
  currentFilters
}: DetailedAnalysisSectionProps) {
  const [exportDialogOpen, setExportDialogOpen] = useState(false);

  // Handle search functionality (can be connected to parent component if needed)
  const handleSearch = useCallback((query: string) => {
    // TODO: Implement search logic or pass to parent component
    console.log('Search query:', query);
  }, []);

  // Handle export functionality
  const handleExport = useCallback(() => {
    setExportDialogOpen(true);
  }, []);

  // BREAKING CHANGE: Replace 4-tab interface with unified table
  return (
    <div className="space-y-6">

      {/* Main divergences table */}
      <DivergenciasUnificadasTable
        data={data.divergencias}
        paginacao={data.paginacao}
        loading={loading}
        error={null}
        onPageChange={onPageChange || (() => {})}
        onSearch={handleSearch}
        onExport={handleExport}
      />

      {/* Export Dialog - Updated to work with unified data */}
      <ExportDialog
        open={exportDialogOpen}
        onOpenChange={setExportDialogOpen}
        data={data}
        currentFilters={currentFilters}
        section="unified" // New section type for unified data
      />
    </div>
  );
}